module.exports = __webpack_public_path__ + "9ffc8568.svg";